import { Button, TextField, DialogActions, DialogTitle } from "@mui/material";
import ShowFullScreenBackdrop from "components/ShowFullScreenBackdrop";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addRole, updateRole } from "service/permission/Role";

const RoleForm = ({ handleClose, handleData, fetchRoleList }) => {
  const [role, setRole] = useState(handleData?.role || "");
  const [open, setOpen] = useState(false);
  const roleId = handleData?._id;

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const roleAddData = {
      role,
    };

    const roleUpdateData = {
      role,
    };

    try {
      setOpen(true);
      let response;
      if (roleId) {
        response = await updateRole(roleUpdateData, roleId);
      } else {
        response = await addRole(roleAddData);
      }

      if (response.status === 200 || response.status === 201) {
        handleClose();
        await fetchRoleList();
        const successMessage = roleId
          ? "Role updated successfully!"
          : "Role added successfully!";
        toast.success(successMessage);
        setOpen(false);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error(
          `Failed to ${roleId ? "update" : "add"} the role. Please try again.`
        );
      }
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <DialogTitle sx={{ fontSize: "18px", fontWeight: "600" }}>
        {roleId ? "UPDATE ROLE" : "ADD ROLE"}
      </DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            padding: "1rem",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Role"
            name="role"
            color="secondary"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          />
        </div>
        <DialogActions>
          <Button
            variant="contained"
            sx={{ margin: "1em" }}
            color="error"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="info"
            sx={{ margin: "1rem" }}
          >
            {roleId ? "Update Role" : "Add Role"}
          </Button>
        </DialogActions>
      </form>
      {open && <ShowFullScreenBackdrop open={open} />}
    </>
  );
};

export default RoleForm;
